import React from 'react'
import { useDispatch } from 'react-redux'
import { setKambiVisibility } from '../Store'
import { toggleKambiVisiblity } from '../helpers/visibility'

export const useToggleVisibility = (isHidden: boolean): void => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (isHidden) {
      dispatch(setKambiVisibility(false))
      toggleKambiVisiblity(false)
    } else {
      dispatch(setKambiVisibility(true))
    }

    return () => {
      dispatch(setKambiVisibility(false))
      toggleKambiVisiblity(false)
    }
  }, [isHidden, dispatch])
}
